/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export enum AttributeNames {
  CONNECT_TYPE = 'connect.type',
  CONNECT_NAME = 'connect.name',
}

export enum ConnectTypes {
  MIDDLEWARE = 'middleware',
  REQUEST_HANDLER = 'request_handler',
}

export enum ConnectNames {
  MIDDLEWARE = 'middleware',
  REQUEST_HANDLER = 'request handler',
}
